import { action, computed, makeObservable, observable } from 'mobx';

export type UnlicensedToggleState = 'show-licensed' | 'show-licensed-and-unlicensed';

class UnlicensedToggleStore {
  @observable
  state: UnlicensedToggleState = 'show-licensed';

  constructor() {
    makeObservable(this);
  }

  @action
  toggle = () => {
    this.state = this.state === 'show-licensed' ? 'show-licensed-and-unlicensed' : 'show-licensed';
  };

  @computed
  get showUnlicensed(): boolean {
    return this.state === 'show-licensed-and-unlicensed';
  }
}

export default UnlicensedToggleStore;
